var exports = {
  "LA": "x127c5a35--ee8365--iframe-container",
  "pU": "x127c5a35--ee8365--iframe",
  "u1": "x127c5a35--ee8365--spinner",
};

module.exports = exports;
